import { BarsOutlined, DownOutlined } from '@ant-design/icons';
import { Button, Divider, Dropdown, Input, Switch } from 'antd';
import { useCallback, useState } from 'react';

import * as S from './ColumnVisibilityDropdown.styled';

export type IColumnGroup = {
  label: string;
  columns: Array<{ key: string; label: string }>;
};

type IColumnVisibilityDropdownProps = {
  groups: IColumnGroup[];
  visibleKeys: string[];
  onToggle: (key: string) => void;
  onReset: () => void;
};

export default function ColumnVisibilityDropdown({
  groups,
  visibleKeys,
  onToggle,
  onReset,
}: IColumnVisibilityDropdownProps) {
  const [searchQuery, setSearchQuery] = useState('');

  const handleOpenChange = useCallback((open: boolean) => {
    if (!open) setSearchQuery('');
  }, []);

  const query = searchQuery.toLowerCase();

  const filteredGroups = groups
    .map(group => ({
      ...group,
      columns: query
        ? group.columns.filter(col => col.label.toLowerCase().includes(query))
        : group.columns,
    }))
    .filter(group => group.columns.length > 0);

  const panel = (
    <S.DropdownPanel>
      <S.PanelHeader>
        <S.PanelTitle>Gerenciar colunas</S.PanelTitle>
        <S.ResetLink type="button" onClick={onReset}>
          Restaurar padrão
        </S.ResetLink>
      </S.PanelHeader>

      <S.SearchWrapper>
        <Input
          placeholder="Buscar coluna..."
          value={searchQuery}
          onChange={e => setSearchQuery(e.target.value)}
          allowClear
          size="small"
        />
      </S.SearchWrapper>

      <S.ColumnList>
        {filteredGroups.map((group, index) => (
          <div key={group.label}>
            {index > 0 && <Divider style={{ margin: 0 }} />}
            <S.GroupLabel>{group.label}</S.GroupLabel>
            {group.columns.map(col => (
              <S.ColumnRow key={col.key} onClick={() => onToggle(col.key)}>
                <span>{col.label}</span>
                <Switch
                  size="small"
                  checked={visibleKeys.includes(col.key)}
                  onChange={() => onToggle(col.key)}
                  onClick={(_checked, e) => e.stopPropagation()}
                />
              </S.ColumnRow>
            ))}
          </div>
        ))}
      </S.ColumnList>
    </S.DropdownPanel>
  );

  return (
    <Dropdown
      dropdownRender={() => panel}
      trigger={['click']}
      onOpenChange={handleOpenChange}
      placement="bottomRight"
      autoAdjustOverflow={false}
    >
      <Button icon={<BarsOutlined />}>
        Colunas <DownOutlined />
      </Button>
    </Dropdown>
  );
}
